import * as React from 'react';
import Search from 'antd/lib/input/Search';
import { useDispatch } from 'react-redux';
import { updateApprovalsSearch } from '../actions/approvalsSearch';

const ApprovalsSearchComponent: React.FC = () => {
    const dispatch = useDispatch();

    const onSearch = (value) => {
        const query = value;
        dispatch(updateApprovalsSearch({ query }));
    };

    return (
        <div>
            <Search placeholder="search by title" allowClear onSearch={onSearch} style={{ width: 200 }} />
        </div>
    );
};

export default ApprovalsSearchComponent;
